import React, { Component } from 'react';
import waiting from '../res/waiting.png';
import { getActiveTeam } from '../Teams/index.js';
import success from '../assets/check_circle_24px.png';
import Popup from "reactjs-popup";
import closeButton from '../close-button.png';
import { Modal } from "react-bootstrap";
import * as API from '../api.js';
import '../style.css';
import Settings from '../sidebaricon/Settings.png';
import editIcon from '../edit.svg';
import editActive from '../Icon/editActive.svg';
import ButtonWithIcon from '../ReusableComponents/ButtonWithIcon.js';
import ChangeMobileNumber from '../userAuth/ChangeMobileNumber.js';
import verifiedIcon from '../assets/tick-mark.png';
import UpdateSecondaryInfo from '../ReusableComponents/UpdateSecondaryInfo.js'
import Button from '../ReusableComponents/Button/Button.js';

class MyProfile extends Component {

    state = {
        subscriptions: [],
        user: {},
        type: "",
        avatarURL: '',
        createIcon: waiting,
        org: {},
        models: [],
        model: {},
        subscriptionTitleMap: {
            "aerogcs_plan_pro": "AeroMegh Pro",
            "aerogcs_plan_free": "AeroMegh Free",
            "aeromegh_plan_pro": "AeroMegh Pro",
            "aeromegh_plan_free": "AeroMegh Free",
            "aerostream_plan_starter": "AeroStream Starter",
            "aerostream_plan_pro": "AeroStream Pro"
        },
        isEditing: false,
        isPersonalDetailsEditable: false,
        isAddressDetailsEditable: false,
        isBillingDetailsEditable: false,
        isGSTNumberEditable: false,
        billingDetails: {
            full_name: "-",
            company_name: "-",
            billing_address: "-",
            gst_number: "-",
            mob_number: "-",
            billing_email: "-",
            pin_code: "-",
            country: "-",
            state: "-"
        },
        personalDetailsWarning: { invalidPhone: false, invalidEmail: false, samePhone: false },
        activeTeam: undefined,
        changeMobileNumberPopup: false,
        avatarUrlData: '',
        avatarUrlData1: '',
        countryLoader: true,
        stateLoader: true,
        countries: [],
        states: [],
        billingStates: [],
        billingStateLoader: false,
        isBillingPhoneInvalid: false,
        isBillingPhoneSameAsUser: false,
        isBillingEmailInvalid: false,
        isBillingNameInvalid: false,
        showUpdateSecondaryDetailsPopup: false,
        missingFields: [],
        billingDetailsBackup: {},
        isPincodeInvalid: false,
        isBillingEmailSameAsUser: false,
    }

    getAllSubscriptions = () => {
        API.getAllSubscriptions().then((data) => {
            this.setState((state) => ({
                ...state,
                subscriptions: data.subscriptions
            }))
        }, (e) => { console.log(e); })
    }

    isNoAnyChangesMade = () => {
        return (
            this.state.user.address === this.props.user.address
            && this.state.user.first_name === this.props.user.first_name
            && this.state.user.last_name === this.props.user.last_name
            && this.state.user.state === this.props.user.state
            && this.state.user.country === this.props.user.country
            && this.state.user.phone === this.props.user.phone
            && this.state.avatarUrlData == this.state.avatarUrlData1
        )
    }

    submitEditUser = (e, mobileVerified = false, updateAvtar = false, skipPhoneCheck = false) => {
        if (e) e.preventDefault();
        const submitUser = (user) => {
            let stateiso = this.state.states.find(x=>{
                return x.name == user.state
            })

            user.stateiso = stateiso.isoCode
            
            API.Useredit(user, this.state.billingDetails).then(() => {
                API.getUserType().then(([blah, type, user]) => {
                    if (!user.sub) {
                        user.sub = {
                            "plan": "aeromegh_plan_free"
                        }
                    }
                    this.setState((state) => ({
                        ...state,
                        user,
                        type,
                    }), () => {
                        this.props.save();
                    });
                });
            }).catch(err => {
                alert(err.message)
            });
        };

        if (updateAvtar) {
            submitUser(this.state.user);
        } else if (!skipPhoneCheck && this.state.user.phone !== this.props.user.phone && !mobileVerified) {
            this.setState({ changeMobileNumberPopup: true });
        } else {
            this.setState({ loading: true });
            let user = this.state.user;
            user.country = user.country === '-' ? '-' : user.country;
            user.state = user.state === '-' ? '-' : user.state;
            user.phone = mobileVerified || this.state.user.phone;
            submitUser(user);
        }
    };

    handleSavePersonalDetails = (e) => {
        if (!this.checkPersonalDetails()) {
            this.setState({ isPersonalDetailsEditable: false }, () => {
                this.submitEditUser(e, false, false, false);
            });
        }
    };

    handleSaveAddressDetails = (e) => {
        if (!this.checkAddressDetails()) {
            this.setState({ isAddressDetailsEditable: false }, () => {
                this.submitEditUser(e, false, false, true);
            });
        }
    };


    toggleSubCancelPopup = () => { document.getElementById("send-plan-popup-button").click() }

    getAeromeghPlans = () => {
        API.getAeromeghPlans().then(res => {
            if (res.plans.length > 0) {
                this.setState((state) => ({
                    ...state,
                    plans: res.plans
                }))
            } else {
                return 0
            }
        }).catch(e => { console.log(e) })
    }

    getBillingDetails = () => {
        API.getBillingDetails()
            .then(res => {
                this.setState({ billingDetails: res }, () => {
                    this.makeFieldsEditable();
                });
            })
            .catch(err => {
                this.setState({ error: "Failed to load billing details" });
            });
    }


    getSelectedActiveTeam = async () => {
        try {
            let selectedActiveTeam = await getActiveTeam();
            this.setState({ activeTeam: selectedActiveTeam })
        } catch (err) { console.log("error : ", err) }
    }

    getCountries = () => {
        API.getCountries().then((data) => {
            let userCountry = this.state.user.country && this.state.user.country !== '-' ? this.state.user.country : '-';
            let billingCountry = this.state.billingDetails.country && this.state.billingDetails.country !== '-' ? this.state.billingDetails.country : '-';

            this.setState((state) => ({
                ...state,
                countryLoader: false,
                countries: data.countries,
                user: {
                    ...state.user,
                    country: userCountry,
                },
                billingDetails: {
                    ...state.billingDetails,
                    country: billingCountry,
                }
            }));

            const userCountryData = data.countries.find(c => c.country === userCountry);
            const billingCountryData = data.countries.find(c => c.country === billingCountry);

            if (userCountryData) {
                this.getStates(userCountryData.iso_code, 'address');
            } else {
                this.setState({ stateLoader: false });
            }

            if (billingCountryData) {
                this.getStates(billingCountryData.iso_code, 'billing');
            }
        }).catch((e) => {
            console.log(e);
        });
    }

    getStates = (iso_code, context = 'address') => {
        if (iso_code) {
            API.getStates(iso_code).then((data) => {
                if (context === 'billing') {
                    this.setState({
                        billingStateLoader: false,
                        billingStates: data.states || [],
                    });
                } else {
                    let userstate = this.state.countryChange && data.states && data.states.length > 0 ? '-' : this.state.user.state;
                    if (!this.state.countryChange && this.state.user.state) {
                        userstate = this.state.user.state;
                    }
                    this.setState({
                        stateLoader: false,
                        states: data.states,
                        user: {
                            ...this.state.user,
                            state: userstate,
                            countryChange: false,
                        },
                    });
                }
            }).catch((e) => {
                console.error('Error loading states:', e);
                this.setState({
                    [context === 'billing' ? 'billingStateLoader' : 'stateLoader']: false,
                    error: 'Failed to load states',
                });
            });
        }
    };


    makeFieldsEditable() {
        const shouldMakeEditable =
            this.state.user.first_name === null ||
            this.state.user.last_name === null ||
            this.state.user.phone === "-" ||
            this.state.user.country === null ||
            this.state.user.state === null ||
            this.state.user.address === null ||
            this.state.user.pin_code === null ||
            this.state.billingDetails.full_name === undefined ||
            this.state.billingDetails.full_name === null ||
            this.state.billingDetails.mob_number === undefined ||
            this.state.billingDetails.mob_number === null ||
            this.state.billingDetails.billing_email === undefined ||
            this.state.billingDetails.billing_email === null ||
            this.state.billingDetails.gst_number === undefined ||
            this.state.billingDetails.gst_number === null ||
            this.state.billingDetails.company_name === undefined ||
            this.state.billingDetails.company_name === null;

        if (shouldMakeEditable) {
            this.setState({
                isEditing: true,
                isPersonalDetailsEditable: true,
                isAddressDetailsEditable: true,
                isBillingDetailsEditable: true,
                isGSTNumberEditable: true,
                billingDetailsBackup: { ...this.state.billingDetails }
            });
        }
    }


    componentDidMount() {
        API.getViewerMinutesStats().then((r) => { this.setState({ viewMinutesStats: r }); }).catch((e) => { alert(e); });
        this.handleCheckSecondaryInfo();
        this.getBillingDetails();
    }

    async handleCheckSecondaryInfo() {
        try {
            const res = await API.checkSecondaryInfo(this.state.user.id);
            if (res.showModal) {
                if (res.showModal) {
                    this.setState({
                        showUpdateSecondaryDetailsPopup: true,
                        missingFields: res.missingFields,
                    });
                } else {
                    this.setState({
                        showUpdateSecondaryDetailsPopup: false,
                        missingFields: [],
                    });
                }
            }
        } catch (e) {
            alert(e);
        }
    }


    canUserUpgrade = (sub) => { return this.state.subscriptionTitleMap[sub] == "AeroMegh Free" ? true : false }

    componentWillMount() {
        document.title = "My Profile - AeroMegh";
        if (this.props) {
            let { user, type } = this.props;
            if (!user.sub) {
                user.sub = {
                    "plan": "aeromegh_plan_free"
                }
            }
            if (user.avatar_url && user.avatar_url.length > 0) {
                this.setState((state) => ({
                    ...state,
                    avatarURL: `${user.avatar_url}?${user.sas_token}&t${new Date().getTime()}`
                }))

            } else {
                let avatarURL = `/images/${user.first_name[0].toLowerCase()}.PNG`
                this.setState((state) => ({
                    ...state,
                    avatarURL: avatarURL
                }))
            }
            this.setState((state) => ({
                ...state,
                user,
                type,
            }), async () => {

                this.getAeromeghPlans();
                this.getAllSubscriptions();
                this.getSelectedActiveTeam();
                this.getCountries();
                this.getBillingDetails();
            })
        } else {
            API.getUserType().then(([blah, type, user]) => {
                if (!user.sub) {
                    user.sub = {
                        "plan": "aeromegh_plan_free"
                    }
                }

                this.setState((state) => ({
                    ...state,
                    user,
                    type
                }), async () => {
                    this.getAeromeghPlans();
                    this.getAllSubscriptions();
                    this.getSelectedActiveTeam();
                    this.getCountries();
                    this.getBillingDetails();
                })
            }, (e) => {
                window.location.replace("/login");
            })
        }
    }

    handleUserDetails = (e) => {
        let name = e.target.name;
        let value = e.target.value;

        const check = (checkData) => {
            let expression = checkData == 'eml'
                ? /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/
                : /^\d{10}$/;
            let len = checkData == 'eml' ? 30 : 10;

            if (value.length <= len) {
                const updatedUser = { ...this.state.user, [name]: value || "" };

                // Validation flags
                let updatedWarnings = { ...this.state.personalDetailsWarning };

                if (expression.test(value)) {
                    if (checkData === 'eml') updatedWarnings.invalidEmail = false;
                    else updatedWarnings.invalidPhone = false;
                } else {
                    if (checkData === 'eml') updatedWarnings.invalidEmail = true;
                    else updatedWarnings.invalidPhone = true;
                }

                // Check samePhone after setting value
                if (name === 'phone' && this.state.billingDetails?.mob_number === value) {
                    updatedWarnings.samePhone = true;
                } else if (name === 'phone') {
                    updatedWarnings.samePhone = false;
                }

                this.setState({
                    user: updatedUser,
                    personalDetailsWarning: updatedWarnings
                });
            }
        };

        if (name === 'phone') {
            check(); // will handle both validation + samePhone
        } else if (name === 'pin_code') {
            // Allow 6-10 digits
            if (/^\d{0,10}$/.test(value)) {
                this.setState({
                    user: { ...this.state.user, [name]: value || "" },
                    isPincodeInvalid: value.length > 0 && !/^\d{6,10}$/.test(value)
                });
            }
        } else if (name === 'country') {
            this.setState(
                {
                    user: { ...this.state.user, [name]: value || "", state: '-' },
                    stateLoader: true
                },
                () => {
                    this.state.countries.forEach(country => {
                        if (country.country === value) this.getStates(country.iso_code);
                    });
                }
            );
        } else if (name === 'username') {
            check('eml'); // email validation
        } else if (value.length <= 30) {
            this.setState({ user: { ...this.state.user, [name]: value || "" } });
        }
    };

    getBase64 = file => {
        return new Promise(resolve => {
            let fileSize = file.size / 1000
            if (fileSize > (this.state.FILE_SIZE_LIMIT * 1000)) {
                this.setState((state) => ({
                    ...state,
                    selectedFile: file,
                    sizeCheckPopup: true
                }))
            }
            else {
                let baseURL = "";
                // Make new FileReader
                let reader = new FileReader();
                // Convert the file to base64 text
                reader.readAsDataURL(file);
                // on reader load somthing...
                reader.onload = () => {
                    // Make a fileInfo Object
                    baseURL = reader.result;
                    resolve(baseURL);
                };
            }
        });
    };

    checkPersonalDetails = () => {
        const { first_name, last_name, phone } = this.state.user;
        const { invalidPhone } = this.state.personalDetailsWarning;

        const isEmpty = (value) => !value || value.trim() === "";

        const isPhoneInvalid = () => {
            return (
                !phone ||
                phone === "-" ||
                !/^\d{10}$/.test(phone)
            );
        };

        return (
            invalidPhone ||
            isEmpty(first_name) ||
            isEmpty(last_name) ||
            isPhoneInvalid()
        );
    };


    checkAddressDetails = () => {
        const { address, country, state, pin_code } = this.state.user;

        const isInvalid = (value) =>
            !value || value.trim() === "" || value.trim() === "-";

        const isPinCodeInvalid = () => {
            return (
                !pin_code ||
                pin_code === "-" ||
                !/^\d{6,10}$/.test(pin_code)
            );
        };

        return (
            isInvalid(address) ||
            isInvalid(country) ||
            isInvalid(state) ||
            isInvalid(pin_code) ||
            isPinCodeInvalid()
        );
    };


    handleBillingDetails = (e) => {
        const { name, value } = e.target;
        if (name === 'full_name') {
            const sanitizedValue = value
                .replace(/[^A-Za-z ]/g, '')
                .replace(/\s+/g, ' ')

            const isValid = /^[A-Za-z]+( [A-Za-z]+)*$/.test(sanitizedValue) && sanitizedValue.length >= 3;

            this.setState((prevState) => ({
                billingDetails: {
                    ...prevState.billingDetails,
                    [name]: sanitizedValue,
                },
                isBillingNameInvalid: !isValid,
            }));
        } else if (name === 'country') {
            this.setState(
                {
                    billingDetails: { ...this.state.billingDetails, [name]: value || '', state: '-' },
                    billingStateLoader: true,
                },
                () => {
                    if (value !== '-') {
                        this.state.countries.forEach((country) => {
                            if (country.country === value) {
                                this.getStates(country.iso_code, 'billing');
                            }
                        });
                    } else {
                        this.setState({ billingStates: [], billingStateLoader: false });
                    }
                }
            );
        } else {
            this.setState((prevState) => ({
                billingDetails: {
                    ...prevState.billingDetails,
                    [name]: value
                }
            }), () => {
                if (name === 'country') {
                    const selected = this.state.countries.find(c => c.country === value);
                    if (selected) {
                        this.getStates(selected.iso_code, 'billing');
                    }
                }
            });
        }
    };


    checkGeneralBillingDetails = () => {
        const { billingDetails } = this.state;

        const isInvalid = (value) =>
            !value || value.trim() === "" || value.trim() === "-";

        return (
            this.state.isBillingNameInvalid ||
            this.state.isBillingPhoneInvalid ||
            !billingDetails.full_name ||
            isInvalid(billingDetails.mob_number)
        );
    };

    checkGSTDetails = () => {
        const gst = this.state.billingDetails?.gst_number?.trim();
        const company = this.state.billingDetails?.company_name?.trim();

        const isCompanyNameEmpty = !company;

        const isLikelyGST = gst?.length === 15;

        const isLikelyVAT = gst?.length >= 7 && gst?.length <= 20;

        const isGSTorVATValid = isLikelyGST || isLikelyVAT;

        return !isGSTorVATValid || isCompanyNameEmpty;
    };



    isBillingDetailsSameAsUser = () => {
        const { billingDetails } = this.state;
        const { user } = this.props;
        return (
            billingDetails.mob_number === user.phone ||
            billingDetails.billing_email?.trim().toLowerCase() === user.username?.trim().toLowerCase()
        );
    };

    submitBillingInfo = () => {
        const { billingDetails } = this.state;
        API.updateBillingDetails(billingDetails)
            .then((res) => {
                this.setState({
                    billingDetails: res,
                    isBillingDetailsEditable: false,
                });
            })
            .catch((err) => {
                console.error('Failed to update billing info:', err);
                this.setState({ error: 'Failed to update billing info' });
            });
    };

    closeUpdateSecondaryDetailsPopup = () => {
        this.setState((state) => ({ ...state, missingFields: [] }));
    };

    handleEdit = () => {
        this.setState({
            isEditing: true,
            isPersonalDetailsEditable: true,
            isAddressDetailsEditable: true,
            isBillingDetailsEditable: true,
            isGSTNumberEditable: true,
            billingDetailsBackup: { ...this.state.billingDetails }
        });
    }

    handleCancel = () => {
        this.setState({
            isEditing: false,
            isPersonalDetailsEditable: false,
            isAddressDetailsEditable: false,
            isBillingDetailsEditable: false,
            isGSTNumberEditable: false,
            user: { ...this.props.user },
            billingDetails: { ...this.state.billingDetailsBackup },
            personalDetailsWarning: { invalidPhone: false, invalidEmail: false },
            isBillingPhoneInvalid: false,
            isBillingPhoneSameAsUser: false,
            isBillingEmailInvalid: false,
            isBillingEmailSameAsUser: false
        });
    }

    showValidationMessage = () => {
        const errors = [];
        if (this.checkPersonalDetails()) errors.push("personal details");
        if (this.checkAddressDetails()) errors.push("address details");
        if (this.checkGeneralBillingDetails()) errors.push("billing contact details");
        if (this.checkGSTDetails()) errors.push("billing details");
        if (this.isBillingDetailsSameAsUser()) errors.push("billing contact email/phone (must be different from personal details)");

        if (errors.length > 0) {
            alert(`Please fix the following sections before saving:\n${errors.join("\n")}`);
            return true;
        }
        return false;
    }

    checkBillingEmailValidity = (email) => {
        if (!email) return false;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    hasValidationErrors = () => {
        const hasBillingEmailError = this.state.isBillingEmailInvalid || this.state.isBillingEmailSameAsUser;
        return (
            this.checkPersonalDetails() ||
            this.checkAddressDetails() ||
            this.checkGeneralBillingDetails() ||
            this.checkGSTDetails() ||
            hasBillingEmailError ||
            this.isBillingDetailsSameAsUser() ||
            this.state.personalDetailsWarning.samePhone
        );
    }

    handleSaveAll = () => {
        if (!this.showValidationMessage()) {
            const isPhoneChanged = this.state.user.phone !== this.props.user.phone;

            this.setState({
                isEditing: false,
                isPersonalDetailsEditable: false,
                isAddressDetailsEditable: false,
                isBillingDetailsEditable: false,
                isGSTNumberEditable: false
            }, () => {
                this.submitEditUser(null, false, false, !isPhoneChanged);
                this.submitBillingInfo();
            });
        }
    }

    render() {
        let { user, billingDetails, type } = this.state
        let viewerMinutesUsagePercent = null
        if (this.state.viewMinutesStats) {
            if (this.state.viewMinutesStats.quota === 0) {
                viewerMinutesUsagePercent = 100
            } else {
                viewerMinutesUsagePercent = (this.state.viewMinutesStats.used / this.state.viewMinutesStats.quota) * 100
            }
        }
        return (
            this.props.user.username ? <div className="wrapper">
                <input id="avatarUpload" type="file"
                    style={{ display: 'none', width: '0px', height: '0px' }}
                    name="profile_photo" placeholder="Photo" onChange={async (e) => {
                        let val;
                        try { val = URL.createObjectURL(e.target.files[0]); } catch (e) { }
                        let avatar = await this.getBase64(e.target.files[0])
                        this.setState((state) => ({
                            ...state,
                            avatarURL: val,
                            avatarUrlData1: avatar,
                            user: {
                                ...state.user,
                                avatar: avatar
                            }
                        }), () => { this.submitEditUser(undefined, undefined, true) })
                    }} required="" capture />
                <div>
                    <Popup
                        trigger={<button id="send-plan-popup-button" style={{
                            display: "none",
                        }}></button>}
                        modal
                    >
                        <img
                            id="close-popup"
                            src={closeButton} style={{
                                width: "auto",
                                height: "26px",
                                position: "absolute",
                                top: "-13px",
                                right: "-13px",
                                cursor: "pointer"

                            }} onClick={() => {

                                document.getElementById("send-plan-popup-button").click();
                                this.setState((state) => ({
                                    ...state,
                                    createIcon: waiting,
                                    cancelSubsText: 'Cancelling Subscription Please Wait...',
                                }))
                            }}></img>
                        <div >
                            <div style={{ width: "100%", display: "flex" }}>
                                <img src={this.state.createIcon} style={{
                                    width: "auto",
                                    height: "64px",
                                    margin: "30px auto"
                                }} />
                            </div>

                            <>
                                <div style={{ width: "100%", textAlign: "center", marginBottom: '50px' }}>{
                                    this.state.cancelSubsText
                                }</div>

                            </>

                        </div>
                    </Popup>
                    {this.state.changeMobileNumberPopup && <ChangeMobileNumber
                        phone={this.state.user.phone}
                        user={this.props.user}
                        sendOTPbyDefault
                        onClose={() => {
                            this.setState(prevState => ({
                                changeMobileNumberPopup: false,
                                user: {
                                    ...prevState.user,
                                    phone: this.props.user.phone   
                                }
                            }));
                        }}
                        onMobileNumberChanged={(phone) => {
                            console.log("Mobile changed")   
                            this.setState({
                                changeMobileNumberPopup: false
                            })
                            this.submitEditUser(false, phone)
                        }}
                    />}

                    <div className='setting-containt' style={{ width: "-webkit-fill-available", padding: "0px 30px 30px 30px" }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", marginBottom: "20px", position: "fixed", width: "-webkit-fill-available", backgroundColor: "white", padding: "25px 25px 25px 0px", marginLeft: "-3px" }}>
                            <div style={{ display: 'flex', alignItems: "center", gap: "20px" }}>
                                <div>
                                    <img src={this.state.avatarURL}
                                        style={{ borderRadius: "50%", height: '60px', width: '60px', cursor: "pointer" }}
                                        onClick={() => { document.getElementById('avatarUpload').click() }}
                                    />
                                </div>
                                <div>
                                    <div style={{ marginBottom: '-4px', fontWeight: "500", fontSize: '14px' }}>{this.props.user.first_name + " " + this.props.user.last_name}</div>
                                    <div><span style={{
                                        color: '#1f384c80',
                                        fontSize: '11px'
                                    }}>{this.state.activeTeam ? this.state.activeTeam.isOwner ? `${this.props.user.first_name + " " + this.props.user.last_name}` : this.state.activeTeam.teamName : '-'}</span></div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: "20px", alignItems: 'center' }}>
                                {this.state.isEditing ? (
                                    <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center', gap: "15px" }}>
                                        <Button
                                            text="Cancel"
                                            style={{ border: '1px solid #2989cf', backgroundColor: 'white', color: '#2989cf' }}
                                            onClick={this.handleCancel}
                                        />
                                        <Button
                                            isDisabled={this.hasValidationErrors()}
                                            text="Save Changes"
                                            onClick={this.handleSaveAll}
                                            isBtnActive
                                        />
                                    </div>
                                ) : (
                                    <img src={editActive}
                                        style={{ height: "30px", cursor: 'pointer' }}
                                        onClick={this.handleEdit}
                                    />
                                )}
                            </div>
                        </div>
                        <div style={{
                            border: '1px solid #2989cf2e',
                            borderRadius: '5px',
                            marginTop: "120px",
                            marginBottom: "20px",
                            padding: "0 20px"
                        }}>
                            <div style={{
                                display: "flex", justifyContent: "space-between",
                                padding: '15px 10px 10px 10px',
                            }}>
                                <div style={{ fontWeight: "500", fontSize: '14px' }}>Personal Details
                                </div>
                            </div>
                            <div style={{ width: "100%", padding: '0 10px 10px 10px', }}>
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: '13px' }}>First name</div>
                                        {!this.state.isPersonalDetailsEditable ?
                                            <div><span style={{ fontSize: '13px' }}>{user.first_name || '-'}</span></div>
                                            : <div><input type='text'
                                                required
                                                autoFocus
                                                value={user?.first_name || ""}
                                                name='first_name'
                                                placeholder='Enter first name'
                                                className='settings-input'
                                                onChange={(e) => {
                                                    let check = /^[A-Za-z]*$/;
                                                    if (check.test(e.target.value)) this.handleUserDetails(e)
                                                }}
                                            /></div>
                                        }
                                    </div>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: '13px' }}>Last name</div>
                                        {!this.state.isPersonalDetailsEditable ?
                                            <div><span style={{ fontSize: '13px' }}>{user.last_name || '-'}</span></div>
                                            : <div><input type='text'
                                                required
                                                value={user?.last_name || ""}
                                                name='last_name'
                                                placeholder='Enter last name'
                                                className='settings-input'
                                                onChange={(e) => {
                                                    let check = /^[A-Za-z]*$/;
                                                    if (check.test(e.target.value)) this.handleUserDetails(e)
                                                }}
                                            /></div>}
                                    </div>
                                </div>
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: '13px' }}>Phone Number</div>
                                        {!this.state.isPersonalDetailsEditable ?
                                            <div><span style={{ fontSize: '13px' }}>{user.phone || '-'}</span></div>
                                            : <div><input type='text'
                                                required
                                                value={user?.phone || ""}
                                                name='phone'
                                                placeholder='Enter phone number'
                                                className='settings-input'

                                                onChange={(e) => {
                                                    let check = /^[0-9]*$/;
                                                    if (check.test(e.target.value) && e.target.value.length <= 10) this.handleUserDetails(e)
                                                }}
                                            /></div>}
                                    </div>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: '13px' }}>Email</div>
                                        <div><span style={{ fontSize: '13px', marginRight: '10px' }}>{user.username || '-'}</span>
                                            {<img src={verifiedIcon} alt='verified icon' style={{ height: '13px' }} />}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: "flex", }}>
                                    {this.state.personalDetailsWarning.invalidEmail || this.state.personalDetailsWarning.invalidPhone || this.state.personalDetailsWarning.samePhone ? <div style={{ width: "50%" }}>
                                        <div style={{ color: 'red', fontSize: '10px' }}>
                                            {this.state.personalDetailsWarning.invalidEmail && this.state.personalDetailsWarning.invalidPhone
                                                ? 'Please ensure that the email address and phone number you provided.'
                                                : this.state.personalDetailsWarning.invalidEmail
                                                    ? 'please memtion valid email address.'
                                                    : this.state.personalDetailsWarning.invalidPhone
                                                        ? 'Invalid phone number.'
                                                        : this.state.personalDetailsWarning.samePhone
                                                            ? 'Phone number should be different from secondary number.' : ''
                                            }
                                        </div>
                                    </div> : <></>}
                                </div>
                            </div>
                            <div></div>
                        </div>
                        <div style={{
                            border: '1px solid #2989cf2e',
                            borderRadius: '5px',
                            padding: "0 20px"
                        }}>
                            <div style={{
                                display: "flex", justifyContent: "space-between",
                                padding: '15px 10px 10px 10px',
                            }}>
                                <div style={{ fontWeight: "500", fontSize: '14px' }}>Address
                                </div>
                            </div>
                            <div style={{ width: "100%", padding: '0 10px 10px 10px', }}>
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: 'small' }}>Country</div>
                                        {!this.state.isAddressDetailsEditable ?
                                            <div><span style={{ fontSize: 'small' }}>{user.country || '-'}</span></div>
                                            : <div>
                                                <select name="country" style={{ width: "50%" }} className="add-user-form-text" value={this.state.user.country} required
                                                    onChange={(e) => { this.handleUserDetails(e) }}
                                                >
                                                    <option value={'-'} disabled>
                                                        {this.state.countryLoader == true ?
                                                            `Loading Countries` : `Select Country`}
                                                    </option>
                                                    {this.state.countries?.length > 0 ?
                                                        this.state.countries.map((country) => {
                                                            return <option key={country.iso_code} value={country.country}>
                                                                {country.country}
                                                            </option>
                                                        }) :
                                                        <option>no countries found</option>
                                                    }
                                                </select>
                                            </div>
                                        }
                                    </div>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: 'small' }}>State</div>
                                        {!this.state.isAddressDetailsEditable ?
                                            <div><span style={{ fontSize: 'small' }}>{user.state || '-'}</span></div>
                                            : <div>
                                                {!this.state.stateLoader ? <select name="state" style={{ width: "50%", opacity: this.state.stateLoader ? "0.5" : "1" }} className="add-user-form-text" value={this.state.user.state} required onChange={(e) => { this.handleUserDetails(e) }}>
                                                    <option value={'-'} disabled> {`Select State`}  </option>
                                                    {this.state.states?.map((state, key) => {
                                                        return <option value={state.name}>{state.name}</option>
                                                    })}
                                                </select> : <div className="add-user-form-text" style={{ opacity: "0.5", display: "flex", justifyContent: "left", alignItems: "center", width: "25vw" }}>Loading...</div>}
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: 'small' }}>Address</div>
                                        {!this.state.isAddressDetailsEditable ?
                                            <div><span style={{ fontSize: 'small' }}>{user.address || '-'}</span></div>
                                            : <div><input type='text'
                                                required
                                                value={user?.address || ""}
                                                name='address'
                                                placeholder='Enter address'
                                                className='settings-input'
                                                onChange={(e) => this.handleUserDetails(e)}
                                            /></div>
                                        }
                                    </div>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: 'small' }}>Pin Code</div>
                                        {!this.state.isAddressDetailsEditable ?
                                            <div><span style={{ fontSize: 'small' }}>{user.pin_code || '-'}</span></div>
                                            : <div><input
                                                type="text"
                                                maxLength={10}
                                                required
                                                value={user?.pin_code || ""}
                                                name="pin_code"
                                                placeholder="Enter pincode"
                                                className="settings-input"
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d{0,10}$/.test(value)) {
                                                        this.handleUserDetails(e);
                                                    }
                                                }}
                                            /></div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div></div>
                        </div>
                        <div style={{
                            border: '1px solid #2989cf2e',
                            borderRadius: '5px',
                            marginBottom: "20px",
                            padding: "0 20px",
                            marginTop: "20px"
                        }}>
                            <div style={{
                                display: "flex", justifyContent: "space-between",
                                padding: '15px 10px 10px 10px',
                            }}>
                                <div style={{ fontWeight: "500", fontSize: '14px' }}>Billing Contact Details
                                </div>
                            </div>
                            <div style={{ width: "100%", padding: '0 10px 10px 10px', }}>
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: '13px' }}>Full name</div>
                                        {!this.state.isBillingDetailsEditable ?
                                            <div><span style={{ fontSize: '13px' }}>{billingDetails.full_name || '-'}</span></div>
                                            : <div><input type='text'
                                                required
                                                value={this.state.billingDetails?.full_name || ""}
                                                name='full_name'
                                                placeholder='Enter full name'
                                                className='settings-input'
                                                maxLength={50}
                                                onChange={(e) => {
                                                    this.handleBillingDetails(e)
                                                }}
                                            /></div>
                                        }
                                    </div>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: '13px' }}>Email</div>
                                        {!this.state.isBillingDetailsEditable ?
                                            <div><span style={{ fontSize: '13px' }}>{billingDetails.billing_email || '-'}</span></div>
                                            : <div>
                                                <input
                                                    type='email'
                                                    required
                                                    value={billingDetails?.billing_email || ""}
                                                    name='billing_email'
                                                    placeholder='Enter email'
                                                    className='settings-input'
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                                                        const isValid = emailRegex.test(value.trim());
                                                        const isSame = value.trim().toLowerCase() === this.props.user.username?.trim().toLowerCase();

                                                        this.setState(prevState => ({
                                                            billingDetails: {
                                                                ...prevState.billingDetails,
                                                                billing_email: value
                                                            },
                                                            isBillingEmailInvalid: !isValid,
                                                            isBillingEmailSameAsUser: isSame
                                                        }));
                                                    }}
                                                />
                                                {this.state.isBillingEmailInvalid && (
                                                    <div style={{ color: 'red', fontSize: '12px' }}>
                                                        Invalid email address
                                                    </div>
                                                )}
                                                {this.state.isBillingEmailSameAsUser && (
                                                    <div style={{ color: 'red', fontSize: '12px' }}>
                                                        Billing email must not be same as account email
                                                    </div>
                                                )}

                                            </div>}
                                    </div>
                                </div>
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: '13px' }}>Mobile Number</div>
                                        {!this.state.isBillingDetailsEditable ? (
                                            <div><span style={{ fontSize: '13px' }}>{billingDetails.mob_number || '-'}</span></div>
                                        ) : (
                                            <div>
                                                <input
                                                    type='number'
                                                    required
                                                    value={billingDetails?.mob_number || ""}
                                                    name='mob_number'
                                                    placeholder='Enter mobile number'
                                                    className='settings-input'
                                                    onChange={(e) => {
                                                        let value = e.target.value;

                                                        // Remove non-digit characters (just in case)
                                                        value = value.replace(/\D/g, '');

                                                        // Enforce 10-digit limit
                                                        if (value.length > 10) {
                                                            value = value.slice(0, 10);
                                                        }

                                                        const isValid = /^[0-9]{10}$/.test(value);
                                                        const isSame = value === this.props.user.phone;

                                                        this.setState(prevState => ({
                                                            billingDetails: {
                                                                ...prevState.billingDetails,
                                                                mob_number: value
                                                            },
                                                            isBillingPhoneInvalid: !isValid,
                                                            isBillingPhoneSameAsUser: isSame
                                                        }));
                                                    }}
                                                />


                                                {this.state.isBillingPhoneInvalid && (
                                                    <div style={{ color: 'red', fontSize: '12px' }}>
                                                        Invalid phone number. Must be 10 digits.
                                                    </div>
                                                )}
                                                {this.state.isBillingPhoneSameAsUser && !this.state.isBillingPhoneInvalid && (
                                                    <div style={{ color: 'red', fontSize: '12px' }}>
                                                        Phone number cannot be same as your personal phone number.
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>


                                </div>
                            </div>
                            <div></div>
                        </div>

                        <div style={{
                            border: '1px solid #2989cf2e',
                            borderRadius: '5px',
                            marginBottom: "20px",
                            padding: "0 20px",
                            marginTop: "20px"
                        }}>
                            <div style={{
                                display: "flex", justifyContent: "space-between",
                                padding: '15px 10px 10px 10px',
                            }}>
                                <div style={{ fontWeight: "500", fontSize: '14px' }}>Billing Details
                                </div>
                            </div>
                            <div style={{ width: "100%", padding: '0 10px 10px 10px', }}>
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: '13px' }}>GST Number</div>
                                        {!this.state.isGSTNumberEditable ? (
                                            <div>
                                                <span style={{ fontSize: '13px' }}>
                                                    {billingDetails.gst_number || '-'}
                                                </span>
                                            </div>
                                        ) : (
                                            <div>
                                                <input
                                                    type="text"
                                                    required
                                                    value={billingDetails?.gst_number || ""}
                                                    name="gst_number"
                                                    placeholder="Enter GST/VAT number"
                                                    className="settings-input"
                                                    maxLength={15}
                                                    onChange={(e) => {
                                                        const value = e.target.value.toUpperCase();
                                                        const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

                                                        // Allow only alphanumeric characters while typing
                                                        if (/^[0-9A-Z]*$/.test(value)) {
                                                            this.handleBillingDetails(e);

                                                            if (value === "") {
                                                                // Empty input is allowed, clear error
                                                                this.setState({ gstNumberError: null });
                                                            } else if (value.length === 15) {
                                                                if (gstRegex.test(value)) {
                                                                    this.setState({ gstNumberError: null });
                                                                } else {
                                                                    this.setState({ gstNumberError: "Invalid GST number format." });
                                                                }
                                                            } else if (value.length > 0 && value.length < 15) {
                                                                this.setState({ gstNumberError: "GST number must be 15 characters long." });
                                                            }
                                                        }

                                                    }}
                                                />
                                                {this.state.gstNumberError && (
                                                    <div style={{ color: 'red', fontSize: '12px' }}>
                                                        {this.state.gstNumberError}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: '13px' }}>Company Name</div>
                                        {!this.state.isGSTNumberEditable ?
                                            <div><span style={{ fontSize: '13px' }}>{billingDetails.company_name || '-'}</span></div>
                                            : <div><input type='text'
                                                required
                                                value={billingDetails?.company_name || ""}
                                                name='company_name'
                                                placeholder='Enter company name'
                                                className='settings-input'
                                                maxLength={50}
                                                onChange={(e) => {
                                                    this.handleBillingDetails(e)
                                                }}
                                            /></div>}
                                    </div>
                                </div>
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: 'small' }}>Address</div>
                                        <div><span style={{ fontSize: 'small' }}>{user.address || '-'}</span></div>
                                    </div>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: 'small' }}>Pin Code</div>
                                        <div><span style={{ fontSize: 'small' }}>{user.pin_code || '-'}</span></div>
                                    </div>
                                </div>
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: 'small' }}>Country</div>
                                        <div><span style={{ fontSize: 'small' }}>{user.country || '-'}</span></div>
                                    </div>
                                    <div style={{ width: "50%" }}>
                                        <div style={{ color: '#1f384c80', fontSize: 'small' }}>State</div>
                                        <div><span style={{ fontSize: 'small' }}>{user.state || '-'}</span></div>
                                    </div>
                                </div>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div > : <div />
        );
    }
}

export default MyProfile;